// test1603
(1603 && 0);
